export const en = {
  trending: 'trending',
  news: 'news',
  videos: 'videos',
  vid_chan: 'ENTITY / Influencer',
  trends: 'trends',
  topics: 'Topic name',
  influencers: 'influencers',
  tweets_count: 'Tweets Count',
  influencer: 'Influencer',
  hashtags: 'hashtags',
  hashtag: 'hashtag',
  category: 'category',
  reach: 'reach',
  trending_map: 'trending map',
  trending_hashtags: 'trending hashtags',
  trending_news: 'trending news',
  trending_videos: 'trending videos',
  trending_topics: 'trending topics',
  most_mentioned: 'Most Mentioned',
  longest_trending: 'Longest Trending',
  news_country: 'News Trending Today / Country',
  news_topics: 'News / topics',
  trending_news_categories: 'Trending News Categories',
  last_trending_hashtags: 'last 5 h trending hashtags',
  last_trending_videos: 'last 5 h trending videos',
  views: 'Views',
  dislikes: 'dislikes',
  likes: 'likes',
  comments: 'comments',
  bookmarks: 'bookmarks',
  view_all: 'view all',
  sources: 'sources',
  platform: 'platform',
  youtube_channel: 'youtube channel',
  channel: 'channel',
  subscribers: 'subscribers',
  uploaded_video: 'uploaded videos',
  article_details: 'Article Details',
  joined: 'joined',
  total_views: 'total views',
  total_reach: 'Total Reach',
  total_num_views: 'total number of views',
  num_posts: 'number of posts',
  uploads: 'uploads',
  subs: 'subs',
  post: 'post',
  video_details: 'video details',
  topic_details: 'topic details',
  compare_videos_views: 'compare videos views',
  videos_views: 'videos views',
  compare_comments: 'compare comments',
  compare_likes: 'compare likes',
  compare_dislikes: 'compare dislikes',
  video_engagement: 'video engagement',
  sentiment: 'sentiment',
  channel_details: 'channel details',
  channel_sub: 'channel subscribers',
  channel_eng: 'channel engagement',
  channel_trust: 'channel trust',
  uploaded_vid: 'uploaded videos',
  channel_views: 'channel views',
  channel_total_views: 'channel total views',
  compare_vid: 'compare videos',
  search_by_vid: 'search by video title',
  compare_hashtags: 'compare hashtags',
  compare_video_statement:
    'You must compare between at least two to five videos against Each Other',
  compare_hash_statement:
    'You must compare between at least two to five Hashtags against Each Other',
  name: 'name',
  followers: 'Followers',
  following: 'Following',
  engagement: 'engagement',
  reach: 'reach',
  total_mentions: 'total_mentions',
  total_tweets: 'total tweets',
  mentions_percentage: 'Mentions / Percentage',
  Mentions: 'Mentions',
  Top_Languages: 'Top Languages',
  Mentions_By_Gender: 'Mentions By Gender',
  Top_Influencer: 'top influencer',
  Top_Influencer_Entity: 'Top Influencer / ENTITY',
  negative_mentions: 'negative mentions',
  positive_mentions: 'positive mentions',
  neutral_mentions: 'neutral mentions',
  neutral_comments: 'neutral comments',
  negative_tweets: 'negative tweets',
  positive_tweets: 'positive tweets',
  neutral_tweets: 'neutral tweets',
  all_mentions: 'all mentions',
  all_posts: 'all posts',
  negative_videos: 'negative videos',
  positive_videos: 'positive videos',
  neutral_videos: 'neutral videos',
  negative_posts: 'negative posts',
  negative_comments: 'negative comments',
  negative_posts_insta: 'negative posts',
  negative_replies: 'negative replies',
  all_replies: 'all replies',
  all_comments: 'all comments',
  negative_quotes: 'negative quotes',
  all_quotes: 'all quotes',
  positive_posts: 'positive posts',
  positive_replies: 'positive replies',
  positive_quotes: 'positive quotes',
  positive_posts_insta: 'positive posts',
  positive_comments: 'positive comments',
  neutral_posts: 'neutral posts',
  neutral_replies: 'neutral replies',
  neutral_quotes: 'neutral quotes',
  neutral_posts_insta: 'neutral posts',
  all_posts_insta: 'all posts',
  all_videos: 'all videos',

  Platforms: 'platforms',
  Country: 'country',
  trending_rank: 'trending ranks',
  top_mentions_country: 'top mentions country',
  related_hashtags: 'related hashtags',
  first_mention: '1st mention',
  world_map: 'world map',
  choose_name: 'Hashtags Trending 24',
  Hours: 'hours',
  trending_compare: 'trending compare',
  most_mentioned_hashtags: 'most mentioned hashtags',
  mentioned_hashtags: 'mentioned hashtags',
  longest_mentioned_hashtags: 'longest trending hashtags',
  num_views: 'no. of views',
  vid_view: 'video views',
  vid_likes: 'video likes',
  vid_dislikes: 'video dislikes',
  vid_comments: 'video comments',
  CHANNEL_LIKES_DISLIKES: 'CHANNEL LIKES-VS - DISLIKES',
  gained_subs: 'gained subscribers',
  channel_top_videos: 'channel top videos',
  channel_watch_time: 'channel watch time',
  mentions_over_time: 'mentions over time',
  intereset_over_time: 'intereset over time',
  trending_rank_today: 'trending rank today',
  most_viewed_videos: 'Most  Viewed Videos',
  recent_news: 'Recent News',
  compare_on_world_map: 'compare on world map',
  trending_rank_today: 'trending rank today',
  total_mentions: 'total mentions',
  created_on: 'created on',
  created_by: 'created by',
  modified_on: 'modified on',
  modified_by: 'modified by',
  num_of_mentions: 'number of mentions',
  article_details: 'article details',
  Monthly_visits: 'Monthly number of visits',
  related_news_article: 'related news article',
  news_source: 'News Source ',
  has_video: 'has video',
  compare_trends: 'compare trends',
  searched: 'searches',
  hashtag_view: 'hashtag details',
  rank: 'rank',
  Most_Frequent_Words: 'Most Frequent Words',
  Keywords: 'Keywords',
  search_menu: 'search menue...',
  searchBy_newsName: 'search By news Name',
  searchBy_videoTitle: 'searchBy videoTitle',
  sets: 'Sets',
  trashed: 'trashed',
  searchBy_topicName: 'search By Topic Name',
  searchBy_hashtagName: 'search By hashtag Name',
  You_Must: 'You Must',
  Create_Hashtag_analysis: 'Create Hashtag analysis',
  To_see_Sentiments: 'To see Sentiments',
  Create_Hashtag_Analysis: 'Create Hashtag Analysis',
  views: 'views',
  view: 'View',
  name_this: 'Name this',
  mentions: 'Mentions',
  never_trending: 'Never Trending',
  facebook: 'Facebook',
  twitter: 'Twitter',
  youtube: 'Youtube',
  instagram: 'Instagram',
  last_seen: 'Last Seen',
  number_of_views: 'Number of views ',
  news_title: 'News Title',
  source_name: 'Source Name',
  searchBy_sourceName: 'search By source Name',
  Last_Day: 'Last Day',
  trending_now: 'trending now',
  trending_before: 'trending before',
  male: 'Male',
  female: 'Female',
  searches: 'searches',
  top_countries: 'top countries',
  world_map: 'world map',
  topic: 'Topic',
  source: 'source',
  trending_videos_table: 'trending videos table',
  trending_on: 'trending on',
  video_uploaded: 'videos uploaded',
  hashtag_trending_24: 'hashtags trending 24',
  today: 'today',
  yesterday: 'yesterday',
  unanalyzed: 'UNANALYZED',
  clients: 'clients',
  tweets: 'Tweets',
  trending_list: 'trending list',
  Please_Wait_Until: 'Please Wait Until',
  Hashtag_analysis_is_Finished: 'Hashtag analysis is Finished',
  posts_count: 'posts count',
};

export const ar = {
  channel_total_views: 'إجمالي مشاهدات القناة',

  Please_Wait_Until: 'من فضلك انتظر حتي',
  Hashtag_analysis_is_Finished: '  ينتهي تحليل الهاشتاق  ',
  trending_list: 'قائمة الترندات',
  source: 'المصدر',
  topic: 'الموضوع',
  world_map: 'الانتشار حول العالم',
  top_countries: 'الدول الأعلى إشارة ',
  searches: 'عمليات البحث',
  male: 'مذكر',
  female: 'انثي',
  trending_before: 'تتجه من قبل',
  trending_now: 'تتجه الآن',
  Last_Day: 'اخر يوم',
  searchBy_sourceName: 'بحث بإسم المصدر',
  source_name: 'اسم المصدر',
  news_title: 'عنوان الخبر',
  number_of_views: 'عدد المشاهدات',
  last_seen: 'اخر ظهور',
  instagram: 'انستقرام',
  youtube: 'يوتيوب',
  twitter: 'تويتر',
  facebook: 'فيس بوك',
  never_trending: 'لم يكن ترند ابدا',
  mentions: 'اشارات',
  name_this: 'اسم هذا',
  view: 'مشاهدة',
  total_reach: 'إجمالي الوصول',
  Create_Hashtag_Analysis: 'إنشاء تحليل للهاشتاق',
  You_Must: 'يجب عليك',
  Create_Hashtag_analysis: 'إنشاء تحليل للهاشتاق',
  To_see_Sentiments: 'لكي تري نسب الآراء ',
  searchBy_hashtagName: 'بحث بإسم الهاشتاق ',
  searchBy_topicName: 'بحث بإسم الموضوع',
  trashed: 'محذوفات',
  sets: 'المجموعات',
  searchBy_videoTitle: 'بحث بإسم الفيديو',
  searchBy_newsName: 'بحث بإسم الاخبار',
  search_menu: '..قائمة البحث',
  trending: 'الترندات',
  news: 'الاخبار',
  videos: 'الفيديوهات',
  influencers: 'المؤثرون',
  influencer: 'مؤثر',
  trends: 'الترندات',
  vid_chan: ' المؤثر/الكيان',
  hashtags: 'الهاشتاقات',
  tweets_count: 'عدد التغريدات',
  hashtag: 'الهاشتاق',
  channel: 'القناة',
  topics: 'اسم الموضوع',
  category: 'الفئة',
  reach: 'الوصول',
  compare_vid: 'مقارنة الفيديوهات',
  compare_hashtags: 'مقارنة الهاشتاقات',
  search_by_vid: 'بحث بإسم الفيديو',
  video_details: 'تفاصيل الفيديو',
  topic_details: 'تفاصيل الموضوع',
  compare_videos_views: 'مقارنة مشاهدات الفيديو',
  videos_views: ' مشاهدات الفيديو',
  view_all: 'اعرض الكل',
  compare_comments: 'مقارنة التعليقات ',
  compare_likes: 'مقارنة الإعجابات',
  compare_dislikes: 'مقارنة عدم الإعجابات',
  video_engagement: 'تفاعلات الفيديو',
  sentiment: ' نسب الآراء',
  channel_details: 'تفاصيل القناة',
  channel_sub: 'مشتركو القناة',
  channel_eng: 'تفاعلات القناة',
  channel_trust: 'مصداقية القناة',
  uploaded_vid: 'الفيديوهات المُحمّلة',
  channel_views: ' مشاهدات القناة',
  channel_total_view: 'إجمالي مشاهدات القناة',
  views: ' المشاهدات',
  dislikes: 'عدم الإعجابات',
  likes: 'الإعجابات',
  comments: 'التعليقات',
  sources: 'مصادر',
  bookmarks: 'العلامات المرجعية',
  platform: 'المنصة',
  youtube_channel: 'قناة اليوتيوب',
  subscribers: 'المشتركون',
  article_details: 'تفاصيل المقال',
  uploaded_video: 'الفيديوهات المُحمّلة',
  joined: 'انضم',
  total_views: 'إجمالي المشاهدات',
  total_num_views: 'إجمالي المشاهدات',
  num_views: 'عدد المشاهدات',
  num_posts: 'عدد المنشورات',
  uploads: 'تحميل',
  subs: 'مشترك',
  post: 'المنشور',
  compare_video_statement:
    'يجب أن تقارن بين ما لا يقل عن اثنين إلى خمسة فيديوهات ضد بعضها البعض ',

  compare_hash_statement:
    'يجب أن تقارن بين ما لا يقل عن اثنين إلى خمسة هاشتاقات ضد بعضها البعض ',
  name: 'الاسم',
  followers: 'المُتابِعين',
  following: 'المُتابَعين',
  engagement: 'التفاعلات',
  reach: 'الوصول',
  total_mentions: 'إجمالي الإشارات',
  total_tweets: 'اجمالي التغريدات',
  mentions_percentage: 'الإشارات / النسب',
  Mentions: 'الإشارات',
  Top_Languages: 'أعلى اللغات',
  Mentions_By_Gender: 'الإشارة  بالجنس',
  Top_Influencer: 'المؤثر الأعلى',
  Top_Influencer_Entity: 'المؤثر/الكيان الأعلى',
  negative_mentions: 'الإشارات السلبية',
  positive_mentions: 'الإشارات الإيجابية',
  neutral_mentions: 'الإشارات المحايدة',
  negative_tweets: 'التغريدات السلبية',
  positive_tweets: 'التغريدات الإيجابية',
  neutral_tweets: 'التغريدات المحايدة',
  all_mentions: ' جميع الإشارات',
  all_posts: ' جميع المنشورات',
  all_posts_insta: 'جميع المنشورات',
  negative_videos: 'فيديوهات السلبية',
  positive_videos: 'فيديوهات الإيجابية',
  neutral_videos: 'فيديوهات المحايدة',
  neutral_comments: 'التعليقات المحايدة',
  negative_posts: 'المنشورات السلبية',
  negative_replies: 'الردود السلبية',
  negative_quotes: 'الاقتباسات السلبية',
  negative_posts_insta: 'المنشورات السلبية',
  negative_comments: 'التعليقات السلبية',
  positive_posts: 'المنشورات الإيجابية',
  positive_comments: 'التعليقات الإيجابية',
  all_comments: 'كل التعليقات',
  positive_replies: 'الردود الإيجابية',
  positive_quotes: 'الاقتباسات الإيجابية',
  positive_posts_insta: 'المنشورات الإيجابية',
  neutral_posts: 'المنشورات المحايدة',
  neutral_replies: 'الردود المحايدة',
  all_replies: 'كل الردود',
  all_quotes: 'كل الاقتباسات',
  neutral_quotes: 'الاقتباسات المحايدة',
  neutral_posts_insta: 'المنشورات المحايدة',
  all_videos: 'جميع الفيديوهات',
  posts_count: 'عدد المنشورات',
  Platforms: 'المنصات',
  Country: 'الدولة',
  trending_rank: 'معدل الترند',
  Most_Frequent_Words: 'الكلمات الأكثر تكراراً',
  top_mentions_country: 'الدول الأكثر إشارة',
  related_hashtags: 'الهاشتاقات المتعلقة',
  first_mention: 'الإشارة الأُولى',
  world_map: 'الانتشار حول العالم',
  trending_map: 'خريطة الترندات',
  trending_hashtags: 'الهاشتاقات الترند',
  trending_news: 'الاخبار الترند',
  trending_videos: 'الفيديوهات الترند',
  trending_topics: 'المواضيع الترند',
  choose_name: 'الهاشتاقات الترند 24 ',
  last_trending_hashtags: 'اخر 5 ساعات هاشتاقات ترند',
  last_trending_videos: 'اخر 5 ساعات فيديوهات ترند',
  most_mentioned: 'الأكثر إشارة',
  longest_trending: 'الأطول ترند',
  news_country: 'الأخبار الترند اليوم / الدولة',
  news_topics: 'الاخبار/المواضيع',
  trending_news_categories: 'اخبار الفئات الترند',
  Hours: 'الساعات',
  trending_compare: 'مقارنة الترندات',
  most_mentioned_hashtags: 'الهاشتاقات الأكثر إشارة',
  mentioned_hashtags: 'الهاشتاقات المشار اليها',
  longest_mentioned_hashtags: 'أطول علامات التصنيف الترند',
  num_views: 'عدد المشاهدات',
  vid_view: 'مشاهدات الفيديو',
  vid_likes: 'إعجابات بالفيديو ',
  vid_dislikes: 'غير اعجاب الفيديو',
  vid_comments: 'تعليقات الفيديو',
  CHANNEL_LIKES_DISLIKES: 'معحب-غير معجب بالقناة',
  gained_subs: 'المشتركون الجُدد',
  channel_top_videos: 'أهم فيديوهات القناة',
  channel_watch_time: 'مواعيد مشاهدة القناة',
  mentions_over_time: 'الإشارات عبر الوقت',
  intereset_over_time: 'الفائدة عبر الوقت',
  trending_rank_today: 'ترتيب الترندات اليوم',
  most_viewed_videos: 'عناوين الأخبار',
  recent_news: 'أخبار حديثة',
  compare_on_world_map: 'مقارنة تِبعاً للانتشار حول العالم',
  trending_rank_today: 'مؤشر الترندات اليوم',
  total_mentions: 'إجمالي الإشارات',
  created_on: 'أنشأت في',
  created_by: 'أنشأت بواسطة',
  modified_on: 'تم التعديل في',
  modified_by: 'تم التعديل بواسطة',
  num_of_mentions: 'عدد الإشارات',
  article_details: 'تفاصيل المقال',
  Monthly_visits: 'عدد الزيارات الشهرية',
  related_news_article: 'المقالات الاخبارية المتعلقة',
  news_source: 'مصدر الأخبار',
  has_video: 'يملك فيديو',
  compare_trends: 'مقارنة المواضيع',
  hashtag_view: 'تفاصيل الهاشتاق',
  rank: 'رتبة',
  Keywords: 'الكلمات الدلالية',
  trending_videos_table: 'جدول الفيديوهات الترند',
  trending_on: ' ترند في',
  video_uploaded: 'الفيديوهات المُحمّلة',
  hashtag_trending_24: 'الهاشتاقات الترند ٢٤',
  today: 'اليوم',
  yesterday: 'أمس',
  unanalyzed: 'غير محلل',
  clients: 'عملاء',
  tweets: 'تغريدات',
};
